// NPM
import React from "react"

// Shared components
import Description from "src/components/Shared/Description"

// Signup Components
import SignupForm from "./SignupForm"

const Signup = ({ sections, signupForm, lang }) => {
  const signupFormSection = sections.find(s => s.uuid === "signup_form")

  return (
    <div className="Signup">
      <div className="columns">
        <div className="column is-5">
          <h1 className="Signup__title">{signupFormSection.title}</h1>

          <Description
            className="Signup__description"
            description={signupFormSection.description}
          />
        </div>
        <div className="column is-6 is-offset-1">
          <SignupForm
            lang={lang}
            signupForm={signupForm}
            signupFormSection={signupFormSection}
          />
        </div>
      </div>
    </div>
  )
}

export default Signup
